// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-nav-move-access-error {
  width: 560px;
}
.dl-nav-move-access-error__header-icon {
  margin-right: 4px;
  fill: var(--g-color-text-danger);
}
.dl-nav-move-access-error__description {
  margin-bottom: 20px;
}
.dl-nav-move-access-error__list {
  max-height: 420px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Navigation/dialogs/BatchMove/AccessError/AccessError.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,iBAAA;EACA,gCAAA;AACR;AAEI;EACI,mBAAA;AAAR;AAGI;EACI,iBAAA;AADR","sourcesContent":[".dl-nav-move-access-error {\n  width: 560px;\n}\n.dl-nav-move-access-error__header-icon {\n  margin-right: 4px;\n  fill: var(--g-color-text-danger);\n}\n.dl-nav-move-access-error__description {\n  margin-bottom: 20px;\n}\n.dl-nav-move-access-error__list {\n  max-height: 420px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
